import {
  Checkbox,
  IconButton,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  useTheme,
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { ChangeEventHandler } from 'react'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { ETranslationNs } from 'src/types'

interface IProps {
  sort: string
  handleSortChange: (sortName: string) => () => void
  handleCreateOpen: () => void
  handleAllItemsCheck: ChangeEventHandler<HTMLInputElement>
  handleItemsRemove: () => void
  isAllChecked: boolean
  isAllUnchecked: boolean
  isIndeterminated: boolean
}

export const THead = ({
  sort,
  handleSortChange,
  // handleCreateOpen,
  isAllChecked,
  isAllUnchecked,
  isIndeterminated,
  handleAllItemsCheck,
  handleItemsRemove,
}: IProps) => {
  const theme = useTheme()

  const sortDirection = sort.split('-')[1] as 'desc' | 'asc'
  const sortActive = sort.split('-')[0]

  return (
    <TableHead>
      <TableRow style={{ border: 0 }} sx={{ 'td, th': { border: 0, p: '16px 2px' } }}>
        <TableCell align="center">
          <Checkbox
            indeterminate={isIndeterminated}
            sx={{ color: theme.palette.custom.grey2 }}
            onChange={handleAllItemsCheck}
            checked={isAllChecked}
          />
        </TableCell>
        <TableCell>
          <TableSortLabel
            onClick={handleSortChange('connection_name')}
            active={sortActive === 'connection_name'}
            direction={sortDirection}
          >
            <HelperWrapper t="connection-table-column" />
          </TableSortLabel>
        </TableCell>
        <TableCell>
          <TableSortLabel
            onClick={handleSortChange('title')}
            active={sortActive === 'title'}
            direction={sortDirection}
            // sx={{
            //   marginLeft: '20px',
            // }}
          >
            <HelperWrapper t="title-input-label" ns={ETranslationNs.Form} />
          </TableSortLabel>
        </TableCell>
        <TableCell align="center">
          <HelperWrapper t="medial-link-table-column" />
        </TableCell>
        <TableCell align="center">
          <TableSortLabel
            onClick={handleSortChange('type')}
            active={sortActive === 'type'}
            direction={sortDirection}
            sx={{
              marginLeft: '20px',
            }}
          >
            <HelperWrapper t="media-type-table-column" />
          </TableSortLabel>
        </TableCell>
        <TableCell align="center">
          <TableSortLabel
            onClick={handleSortChange('connection_type')}
            active={sortActive === 'connection_type'}
            direction={sortDirection}
            sx={{
              marginLeft: '20px',
            }}
          >
            <HelperWrapper t="media-thumbnail-table-column" ns={ETranslationNs.Form} />
          </TableSortLabel>
        </TableCell>
        <TableCell align="center">
          <TableSortLabel
            onClick={handleSortChange('created_at')}
            active={sortActive === 'created_at'}
            direction={sortDirection}
            sx={{
              marginLeft: '20px',
            }}
          >
            <HelperWrapper t="table-created-column" />
          </TableSortLabel>
        </TableCell>
        <TableCell align="center">
          <TableSortLabel
            onClick={handleSortChange('updated_at')}
            active={sortActive === 'updated_at'}
            direction={sortDirection}
            sx={{
              marginLeft: '20px',
            }}
          >
            <HelperWrapper t="table-modified-column" />
          </TableSortLabel>
        </TableCell>
        {/* <TableCell align="center">
          <Button onClick={handleCreateOpen}>
            <HelperWrapper t="create-media-button-text" />
          </Button>
        </TableCell> */}
        <TableCell align="center">
          <IconButton disabled={isAllUnchecked} onClick={handleItemsRemove}>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    </TableHead>
  )
}
